<template>
  <v-toolbar flat color="white">
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-btn small text outlined v-on="on" :attrs="attrs" color="primary"
          ><v-icon>mdi-filter</v-icon>All Filters</v-btn
        >
      </template>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4" class="px-0">
              <v-autocomplete
                v-model="clientFilter"
                :items="clients"
                return-object
                clearable
                label="Client"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="px-0">
              <v-autocomplete
                v-model="providerFilter"
                :items="providers"
                return-object
                clearable
                label="Provider"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="px-0" v-if="programView === 'SEIT'">
              <v-autocomplete
                v-model="teamFilter"
                :items="teams"
                return-object
                multiple
                clearable
                label="Team"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="px-0" v-if="programView === 'EIO'">
              <v-select
                v-model="eiStaffingTeamFilter"
                :items="eiStaffingTeams"
                clearable
                label="EI Staffing Team"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="px-0">
              <v-autocomplete
                v-model="reportTypeFilter"
                :items="reportTypes"
                return-object
                multiple
                clearable
                label="Report Type"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="px-0">
              <form-field
                :field="monthPicker"
                @fieldChange="dueDateFilter = $event"
                class="mx-1"
              ></form-field>
            </v-col>
            <v-col cols="12" sm="4" class="px-0">
              <v-select
                v-model="statusFilter"
                :items="statuses"
                multiple
                clearable
                label="Status"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="px-0">
              <v-select
                v-model="flagFilter"
                :items="flags"
                clearable
                label="Flag"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" class="px-0" v-if="programView === 'SEIT'">
              <v-select
                v-model="yearOfBirthFilter"
                :items="yearOfBirthOptions"
                multiple
                clearable
                label="Year of Birth"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" class="px-0" v-if="programView === 'EIO'">
              <v-select
                v-model="serviceFilter"
                :items="services"
                multiple
                clearable
                label="Service"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" class="px-0" v-if="programView === 'SEIT'">
              <v-select
                v-model="quarterFilter"
                :items="quarterOptions"
                clearable
                label="Quarter"
                hide-details
                dense
                outlined
                class="mx-1"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="px-0" v-if="programView === 'SEIT'">
              <v-row dense>
                <v-radio-group
                  :value="tenTwelveMonthFilter"
                  row
                  hide-details
                  class="mx-1 mt-1"
                >
                  <v-radio
                    label="10 Month"
                    :value="10"
                    @click.native.stop.prevent="setTenTwelveMonthFilter(10)"
                  ></v-radio>
                  <v-radio
                    label="12 Month"
                    :value="12"
                    @click.native.stop.prevent="setTenTwelveMonthFilter(12)"
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-menu>
    <v-btn small text @click="clearFilters">Clear All</v-btn>
    <v-chip-group column>
      <template v-for="(filter, i) in appliedFilters">
        <v-chip
          :key="i"
          label
          close
          close-icon="mdi-close"
          @click:close="removeFilter(filter)"
          color="primary"
          dark
          small
          class="mx-1"
          >{{ filter.text }}</v-chip
        >
      </template>
    </v-chip-group>
  </v-toolbar>
</template>

<script>
import { formatShortDate } from "../../utils/format-utils";
import { ReportAssignmentStatus } from "../../objs/ReportAssignmentStatus";
import FormField from "../../objs/Shared/FormField";
export default {
  data() {
    return {
      statuses: Object.values(ReportAssignmentStatus),
      tenTwelveMonthFilterGroup: null,
    };
  },
  mounted() {
    this.$emit("applyFilters", this.filteredReports);
  },
  computed: {
    programView() {
      return this.$store.state.reportsModule.programView;
    },
    noCurrentPlan() {
      return (
        this.filteredReports.filter((item) => item.isCurrentPlan).length == 0
      );
    },
    clients() {
      return this.reportAssignments
        .map((item) => {
          if (
            !this.currentPlansFilter ||
            (this.currentPlansFilter && item.isCurrentPlan)
          ) {
            return {
              text: `${item.clientName} (${formatShortDate(
                item.clientDateOfBirth
              )})`,
              value: item.clientId,
            };
          }
        })
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    providers() {
      return this.reportAssignments
        .map((item) => {
          return {
            text: item.providerName,
            value: item.providerId,
          };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    teams() {
      var teams = this.reportAssignments
        .filter((item) => item.teamName != null)
        .map((item) => {
          return {
            text: item.teamName,
            value: item.teamId,
          };
        })
        .sort((a, b) => a.text.localeCompare(b.text));

      teams.push({ text: "No Team", value: "none" });
      return teams;
    },
    eiStaffingTeams() {
      return this.reportAssignments.map((item) => item.eiStaffingTeam);
    },
    services() {
      return this.reportAssignments
        .map((item) => item.service)
        .sort((a, b) => a.localeCompare(b));
    },
    reportTypes() {
      return this.$store.getters["optionsModule/reportTypes"](this.programView)
        .map((item) => {
          return {
            text: item.name,
            value: item.reportTypeId,
          };
        })
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    flags() {
      return this.$store.state.optionsModule.flags;
    },
    monthPicker: function () {
      return new FormField({
        label: "Due Date(s)",
        value: this.dueDateFilter,
        componentName: "month-picker",
      });
    },
    yearOfBirthOptions() {
      return this.reportAssignments
        .map((item) => item.yearOfBirth)
        .sort((a, b) => a - b);
    },
    quarterOptions() {
      return this.reportAssignments
        .sort((a, b) => {
          return new Date(b.dueDate) - new Date(a.dueDate);
        })
        .map((item) => item.quarterByYear);
    },
    clientFilter: {
      get() {
        return this.filters.clientFilter.value || "";
      },
      set(value) {
        this.applyFilter("clientFilter", value);
      },
    },
    providerFilter: {
      get() {
        return this.filters.providerFilter.value || "";
      },
      set(value) {
        this.applyFilter("providerFilter", value);
      },
    },
    teamFilter: {
      get() {
        return this.filters.teamFilter || [];
      },
      set(value) {
        this.applyFilter("teamFilter", value);
      },
    },
    eiStaffingTeamFilter: {
      get() {
        return this.filters.eiStaffingTeamFilter.value || "";
      },
      set(value) {
        this.applyFilter("eiStaffingTeamFilter", { value, text: value });
      },
    },
    serviceFilter: {
      get() {
        return this.filters.serviceFilter.map((item) => item.value) || [];
      },
      set(value) {
        this.applyFilter(
          "serviceFilter",
          value.map((item) => {
            return { value: item, text: item };
          })
        );
      },
    },
    reportTypeFilter: {
      get() {
        return this.filters.reportTypeFilter || [];
      },
      set(value) {
        this.applyFilter("reportTypeFilter", value);
      },
    },
    statusFilter: {
      get() {
        return this.filters.statusFilter.map((item) => item.value) || [];
      },
      set(value) {
        this.applyFilter(
          "statusFilter",
          value.map((item) => {
            return { value: item, text: item };
          })
        );
      },
    },
    dueDateFilter: {
      get() {
        return this.filters.dueDateFilter.map((item) => item.value) || [];
      },
      set(value) {
        this.applyFilter(
          "dueDateFilter",
          value.map((item) => {
            return {
              value: item,
              text: `${item.toLocaleString("default", {
                month: "short",
              })} ${item.getFullYear()}`,
            };
          })
        );
      },
    },
    flagFilter: {
      get() {
        return this.filters.flagFilter.value || "";
      },
      set(value) {
        this.applyFilter("flagFilter", { value, text: value });
      },
    },
    yearOfBirthFilter: {
      get() {
        return this.filters.yearOfBirthFilter.map((item) => item.value) || [];
      },
      set(value) {
        this.applyFilter(
          "yearOfBirthFilter",
          value.map((item) => {
            return { value: item, text: item ? `${item} DOB` : "" };
          })
        );
      },
    },
    quarterFilter: {
      get() {
        return this.filters.quarterFilter.value || "";
      },
      set(value) {
        this.applyFilter("quarterFilter", { value, text: value });
      },
    },
    currentPlansFilter() {
      return this.filters.currentPlansFilter.value;
    },
    tenTwelveMonthFilter: {
      get() {
        return this.filters.tenTwelveMonthFilter.value || "";
      },
      set(value) {
        this.applyFilter("tenTwelveMonthFilter", {
          value,
          text: value ? `${value} Month` : "",
        });
      },
    },
    reportAssignments() {
      return this.$store.state.reportsModule.reportAssignments || [];
    },
    filters() {
      return this.$store.state.reportsModule.filters;
    },
    appliedFilters() {
      var filterValues = Object.values(this.filters).flat();
      return filterValues.filter((item) => Boolean(item.text));
    },
    filteredReports() {
      let reports = this.reportAssignments;
      if (this.providerFilter) {
        reports = reports.filter((t) => t.providerId == this.providerFilter);
      }
      if (this.clientFilter) {
        reports = reports.filter((t) => t.clientId == this.clientFilter);
      }
      if (this.teamFilter.length > 0) {
        reports = reports.filter(
          (t) =>
            this.teamFilter.map((x) => x.value).includes(t.teamId) ||
            t.teamId == null
        );
      }
      if (this.eiStaffingTeamFilter) {
        reports = reports.filter(
          (t) => t.eiStaffingTeam == this.eiStaffingTeamFilter
        );
      }
      if (this.serviceFilter.length > 0) {
        reports = reports.filter((t) => this.serviceFilter.includes(t.service));
      }
      if (this.reportTypeFilter.length > 0) {
        reports = reports.filter(
          (t) =>
            this.reportTypeFilter
              .map((x) => x.value)
              .includes(t.reportTypeId) || t.reportTypeId == null
        );
      }
      if (this.statusFilter.length > 0) {
        reports = reports.filter((t) => this.statusFilter.includes(t.status));
      }
      // by month and year
      if (this.dueDateFilter.length) {
        reports = reports.filter((t) =>
          this.dueDateFilter.some((item) => {
            return (
              new Date(t.dueDate).getMonth() == item.getMonth() &&
              new Date(t.dueDate).getFullYear() == item.getFullYear()
            );
          })
        );
      }
      if (this.flagFilter) {
        reports = reports.filter((t) => t.flag == this.flagFilter);
      }
      if (this.yearOfBirthFilter.length > 0) {
        reports = reports.filter((t) =>
          this.yearOfBirthFilter.includes(t.yearOfBirth)
        );
      }
      if (this.quarterFilter) {
        reports = reports.filter((t) => t.quarterByYear == this.quarterFilter);
      }
      if (this.currentPlansFilter === true) {
        reports = reports.filter((t) => t.isCurrentPlan);
      }
      if (this.currentPlansFilter === false) {
      }
      if (this.tenTwelveMonthFilter) {
        reports = reports.filter(
          (t) => t.tenOrTwelveMonth == this.tenTwelveMonthFilter
        );
      }
      return reports;
    },
  },
  methods: {
    formatShortDate,
    setTenTwelveMonthFilter(value) {
      // this makes the radio-group deselectable
      this.tenTwelveMonthFilter =
        this.tenTwelveMonthFilter === value ? "" : value;
    },
    applyFilter(name, value) {
      // save the value in the store
      this.$store.dispatch("reportsModule/setFilters", {
        filterName: name,
        filterValue: value,
      });
      // emit event with filtered reports (for table)
      this.$emit("applyFilters", this.filteredReports);
    },
    removeFilter(filter) {
      var filterName =
        this.$store.getters["reportsModule/getFilterName"](filter);

      switch (filterName) {
        // filter is array, setter expects value as obj (text, value)
        case "teamFilter":
        case "reportTypeFilter":
          this[filterName] = this[filterName].filter(
            (item) => item.value !== filter.value
          );
          break;
        // filter is array, setter expects value as string
        case "serviceFilter":
        case "statusFilter":
        case "dueDateFilter":
        case "yearOfBirthFilter":
          this[filterName] = this[filterName].filter(
            (item) => item !== filter.value
          );
          break;
        // filter is single, setter expects value as obj (text, value)
        case "clientFilter":
        case "providerFilter":
          this[filterName] = { value: "", text: "" };
          break;
        // filter is single, setter expects value as string
        case "flagFilter":
        case "eiStaffingTeamFilter":
        case "tenTwelveMonthFilter":
        case "quarterFilter":
        default:
          this[filterName] = "";
          break;
      }
    },
    clearFilters() {
      this.$store.dispatch("reportsModule/clearFilters");
      this.$emit("applyFilters", this.filteredReports);
    },
  },
  watch: {
    reportAssignments() {
      this.$emit("applyFilters", this.filteredReports);
    },
    currentPlansFilter() {
      this.$emit("applyFilters", this.filteredReports);
    },
  },
};
</script>
